<template>
  <div>
    <v-data-table :headers="headers" :items="data">
      <template slot="items" slot-scope="props">
        <tr style="text-align:left">
          <td>
            <v-btn
              icon
              color="primary"
              v-if="
                canSubmit(props.item.Application) &&
                  (currentStatus(props.item.CurrentStatus) == 'New' ||
                    currentStatus(props.item.CurrentStatus) == 'Submitted' ||
                    currentStatus(props.item.CurrentStatus) == 'Approved')
              "
              @click="openService(props.item)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              icon
              color="primary"
              v-if="
                (currentStatus(props.item.CurrentStatus) != 'New' &&
                  currentStatus(props.item.CurrentStatus) != 'Submitted' &&
                  currentStatus(props.item.CurrentStatus) != 'Approved') ||
                  !canSubmit(props.item.Application)
              "
              @click="openService(props.item)"
            >
              <v-icon>visibility</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.ApplicationID }}</td>
          <td>{{ userName(props.item.Application.User) }}</td>
          <td>{{
            primarySiteName(props.item.Application.PracticeSiteInformation)
          }}</td>
          <td>{{ currentStatus(props.item.CurrentStatus) }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="1050px" v-if="dialog">
      <service-comp
        :service="service"
        v-on:closeService="closeService"
        v-on:saved="saved"
      ></service-comp>
    </v-dialog>
  </div>
</template>

<script>
import { authComputed } from '@state/helpers'
import moment from 'moment'
import ServiceComplianceVue from './ServiceCompliance.vue'
export default {
  props: {
    data: Array,
    timeframe: Number,
  },
  data() {
    return {
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'Application', value: 'ApplicationID' },
        { text: 'HealthCare Provider', value: 'FirstName' },
        { text: 'Site', value: 'StieInsitutionName' },
        { text: 'Status', value: 'Description' },
      ],
      dialog: false,
      service: {},
    }
  },
  methods: {
    currentStatus(status) {
      if (status.Status) {
        return status.Status.Description
      }
      return 'Not Submitted'
    },
    primarySiteName(sites) {
      let name = ''
      sites.forEach((i) => {
        if (i.IsPrimarySite) {
          name = i.SiteAddress.SiteInsitutionName
        }
      })
      return name
    },
    userName(user) {
      if (user) {
        return `${user.FirstName} ${user.LastName}`
      }
      return ''
    },
    canSubmit(application) {
      //debugger
      let dateto = Date()
      let start = moment(application.DateReward).add(this.timeframe, 'months')
      let substr = start.subtract(1, 'months')
      if (moment(new Date()) > start.subtract(1, 'months')) {
        return true
      }
      return false
    },
    openService(item) {
      this.service = {}
      this.service = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    closeService() {
      this.service = {}
      this.dialog = false
    },
    saved (item) {
            this.service = item
      this.$emit('saved')
    },
  },
  computed: {
    ...authComputed,
  },
  components: {
    'service-comp': ServiceComplianceVue,
  },
}
</script>

<style></style>
